import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, switchMap, takeWhile } from 'rxjs';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: false,
})
export class ConfirmationModalComponent implements OnInit {
  public headerText: string;
  public contentText: string;
  public values: object;

  public submit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private _dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: { headerText: string, contentText: string, values: object }
  ) {
  }

  public ngOnInit(): void {
    this.headerText = this._data.headerText;
    this.contentText = this._data.contentText;
    this.values = this._data.values;
  }

  public emit(confirmation: boolean): void {
    this.submit.emit(confirmation);
  }

  /**
   * Subscribes to results from the confirmation dialog, calling the provided updater function with the result.
   * Displays an alert with an error message upon process failure.
   *
   * @param dialogRef - A reference to the opened confirmation dialog.
   * @param updater - An observable to update the confirmation result.
   * @param onFailMsg - The message to display on failure.
   * @param onSuccess - A callback function to execute on success.
   */
  static useConfirmDialog(
    dialogRef: MatDialogRef<ConfirmationModalComponent>,
    updater: Observable<boolean>,
    onFailMsg: string,
    onSuccess: () => void
  ): void {
    let isOpen = true;
    dialogRef.componentInstance.submit
      .pipe(
        takeWhile(() => isOpen),
        switchMap((confirmation) => {
          if (confirmation) {
            return updater;
          } else {
            throw new Error('Did NOT confirm, use error flow');
          }
        })
      )
      .subscribe({
        next: (r) => {
          if (!r) {
            window.alert(onFailMsg);
          } else {
            // on success, close dialog
            onSuccess();
            dialogRef.close();
            isOpen = false;
          }
        },
        error: (_) => {
          dialogRef.close();
          isOpen = false;
        },
      });
  }
}
